import { Box, Flex } from "@chakra-ui/react";
import { Empty, Modal } from "antd";
import { PaginateQuery } from "core/resources/types/shared";
import React from "react";
import OutlineButton from "ui/components/Button/OutlineButton";
import Pagination from "ui/components/Pagination";
import Tabs from "ui/components/Tabs";
import { PaginateResult } from "core/resources/types/shared";
import CardUnidadeParticipante from "components/Features/Votacao/CardUnidadeParticipante";
import LoadingSkeleton from "./components/LoadingSkeleton";
import { UnidadeParticipanteItem } from "features/assembleia/typings";
import { CloseModalButton } from "components/Button/CloseModalButton";

interface ModalTabsParticipantesProps {
  isOpen: boolean;
  onClose: () => any;
  firstTabTitle: string;
  firstTabFiltro: PaginateQuery;
  firstTabOnPaginate: (p: number) => any;
  firstTabData?: PaginateResult<UnidadeParticipanteItem>;
  firstTabEmptyMessage?: string;
  firstTabRightElement?: React.ReactNode;
  firstTabIsLoading?: boolean;
  secondTabTitle: string;
  secondTabEmptyMessage?: string;
  secondTabFiltro: PaginateQuery;
  secondTabOnPaginate: (p: number) => any;
  secondTabData?: PaginateResult<UnidadeParticipanteItem>;
  secondTabLeftElement?: React.ReactNode;
  secondTabIsLoading?: boolean;
  reenviarNotificacoes?: () => any;
  isLoadingReenviarNotificacoes?: boolean;
  textCreatedAt?: string;
}

const FlexContainer = ({ children }: { children: React.ReactNode }) => (
  <Flex
    flexDir="column"
    h="max(80vh, 400px)"
    pb="90px"
    overflowY="auto"
    className="custom-scroll-bar"
  >
    {children}
  </Flex>
);

const paginationCommonProps = {
  pageSize: 10,
  hideOnSinglePage: true,
  showSizeChanger: false,
};

function ModalTabsParticipantes({
  isOpen,
  onClose,
  firstTabTitle,
  firstTabData,
  firstTabFiltro,
  firstTabOnPaginate,
  firstTabEmptyMessage,
  firstTabRightElement,
  firstTabIsLoading,
  secondTabTitle,
  secondTabData,
  secondTabFiltro,
  secondTabOnPaginate,
  secondTabEmptyMessage,
  secondTabLeftElement,
  secondTabIsLoading,
  reenviarNotificacoes,
  isLoadingReenviarNotificacoes,
  textCreatedAt,
}: ModalTabsParticipantesProps) {
  return (
    <Modal
      destroyOnClose
      title="Visualizações"
      width="650px"
      footer={
        <Flex justifyContent="end">
          <CloseModalButton close={onClose} closeModalLabel="Fechar" />
        </Flex>
      }
      centered
      bodyStyle={{
        maxHeight: "max(80vh, 400px)",
        overflow: "hidden",
        padding: 0,
        backgroundColor: "transparent",
        borderBottomRightRadius: 16,
        borderBottomLeftRadius: 16,
        marginTop: 20,
      }}
      visible={isOpen}
      onCancel={onClose}
    >
      <Tabs.Tab
        containerProps={{
          padding: 0,
          roundedBottom: 16,
        }}
      >
        <Tabs.Panel title={firstTabTitle}>
          <FlexContainer>
            <Box alignSelf="flex-end" mb={"18px"} mt={4} mr={4} minH="24px">
              {firstTabRightElement}
            </Box>
            {firstTabIsLoading ? <LoadingSkeleton /> : null}

            {!firstTabIsLoading && !firstTabData?.items.length ? (
              <Box my="auto">
                <Empty description={firstTabEmptyMessage} />
              </Box>
            ) : null}

            {!firstTabIsLoading ? (
              <>
                {firstTabData?.items.map((unidadeParticipante, index) => (
                  <CardUnidadeParticipante
                    key={index}
                    unidadeParticipante={unidadeParticipante}
                    bordered={index < firstTabData.items.length - 1}
                    textCreatedAt={textCreatedAt}
                  />
                ))}
                <Pagination
                  current={firstTabFiltro.page}
                  onChange={firstTabOnPaginate}
                  total={firstTabData?.meta.totalItems}
                  {...paginationCommonProps}
                />
              </>
            ) : null}
          </FlexContainer>
        </Tabs.Panel>

        <Tabs.Panel title={secondTabTitle}>
          <FlexContainer>
            {secondTabIsLoading ? (
              <>
                <Box mb={"18px"} mt={4} mr={4} minH="24px" />
                <LoadingSkeleton />
              </>
            ) : null}

            {!secondTabIsLoading && !secondTabData?.items.length ? (
              <Box my="auto">
                <Empty description={secondTabEmptyMessage} />
              </Box>
            ) : null}

            {!secondTabIsLoading ? (
              <>
                {secondTabData?.items.length ? (
                  <Flex>
                    {secondTabLeftElement}

                    {reenviarNotificacoes ? (
                      <Box ml="auto" mb={2} mt={2} mr={2}>
                        <OutlineButton
                          onClick={() => reenviarNotificacoes()}
                          isLoading={isLoadingReenviarNotificacoes}
                        >
                          Notificar todos
                        </OutlineButton>
                      </Box>
                    ) : null}
                  </Flex>
                ) : null}

                {secondTabData?.items.map((unidadeParticipante, index) => (
                  <CardUnidadeParticipante
                    key={index}
                    unidadeParticipante={unidadeParticipante}
                    bordered={index < secondTabData.items.length - 1}
                    textCreatedAt={textCreatedAt}
                  />
                ))}
                <Pagination
                  current={secondTabFiltro.page}
                  onChange={secondTabOnPaginate}
                  total={secondTabData?.meta.totalItems}
                  {...paginationCommonProps}
                />
              </>
            ) : null}
          </FlexContainer>
        </Tabs.Panel>
      </Tabs.Tab>
    </Modal>
  );
}

export default ModalTabsParticipantes;
